import { useLang } from "@/i18n/LangContext";
import { useContent } from "@/context/SiteContext";
import { Seo, faqJsonLd } from "@/lib/seo";
import { FaqSection, usePageFaqs } from "@/components/common/FaqSection";
import { Hero } from "@/components/home/Hero";
import { Attributes } from "@/components/home/Attributes";
import { Marquee } from "@/components/motion/Marquee";
import { Presentation } from "@/components/home/Presentation";
import { RoomsSpotlight } from "@/components/home/RoomsSpotlight";
import { CorporateHub } from "@/components/home/CorporateHub";
import { Gastronomy } from "@/components/home/Gastronomy";
import { LocationCard } from "@/components/home/LocationCard";
import { GalleryEditorial } from "@/components/home/GalleryEditorial";
import { DirectBenefits, Testimonials, ContactStrip } from "@/components/home/Extras";

export default function Home() {
  const { t, lang, L } = useLang();
  const c = useContent();
  const faqs = usePageFaqs("home");
  return (
    <main data-testid="home-page">
      <Seo title={c("meta_home_title", lang)} home description={c("meta_home_desc", lang)} image="/images/og/og-default.jpg" jsonLd={faqJsonLd(faqs, L)} />
      <Hero />
      <Attributes />
      <Marquee items={t.marquee} />
      <Presentation />
      <RoomsSpotlight />
      <CorporateHub />
      <Gastronomy />
      <LocationCard />
      <GalleryEditorial />
      <DirectBenefits />
      <Testimonials />
      <FaqSection faqs={faqs} eyebrow={t.pages.faq.eyebrow} title={t.pages.faq.home} className="bg-bone" testId="home-faqs" />
      <ContactStrip />
    </main>
  );
}
